import { languages } from "@examspark/common/dist/meta/language";
const DEFAULT_TTS_LANGUAGE = "en";

/*
 * LANGUAGE COMPATIBILITY ANALYSIS FOR TTS SYSTEM
 * =============================================
 *
 * This table shows the compatibility status across different TTS components:
 *
 * | Language | Code | SRE Math Speech | TTS-React Support | Web Speech API | Overall Status |
 * |----------|------|-----------------|-------------------|----------------|----------------|
 * | English  | en   | ✅ Perfect      | ✅ Supported      | ✅ Excellent   | ✅ Perfect     |
 * | Spanish  | es   | ✅ Perfect      | ✅ Supported      | ✅ Excellent   | ✅ Perfect     |
 * | French   | fr   | ✅ Perfect      | ⚠️ Limited        | ✅ Excellent   | ✅ Perfect     |
 * | German   | de   | ✅ Perfect      | ✅ Supported      | ✅ Excellent   | ✅ Perfect     |
 * | Portuguese| pt  | ⚠️ Limited      | ✅ Supported      | ✅ Good        | 🟡 Good        |
 * | Italian  | it   | ⚠️ Limited      | ✅ Supported      | ✅ Good        | 🟡 Good        |

/**
 * Gets the appropriate language for TTS based on configuration hierarchy:
 * 1. Question/item language
 * 2. Exam language
 * 3. Config language
 * 4. Default
 */

export const getLanguageForTts = (
  questionLanguage: string[] = [],
  examLanguage: string[] = [],
  configLanguage: string = DEFAULT_TTS_LANGUAGE,
): string => {
  let selectedLanguage: string;
  let source: string;

  if (questionLanguage?.[0]) {
    selectedLanguage = questionLanguage[0];
    source = "question language (highest priority)";
  } else if (examLanguage?.[0]) {
    selectedLanguage = examLanguage[0];
    source = "exam language (second priority)";
  } else if (configLanguage) {
    selectedLanguage = configLanguage;
    source = "config language (third priority)";
  } else {
    selectedLanguage = DEFAULT_TTS_LANGUAGE;
    source = "default fallback (lowest priority)";
  }

  console.log(`✅ Selected: "${selectedLanguage}" from ${source}`);

  const language = selectedLanguage.toLowerCase();

  const normalizeLanguage = (lang: string): string => {
    const langMap: Record<string, string> = {};

    languages.forEach(([, code]) => {
      langMap[code] = code.toLowerCase();
      langMap[code.toLowerCase()] = code.toLowerCase();
      langMap[code.toUpperCase()] = code.toLowerCase();
    });

    return langMap[lang] || lang.toLowerCase();
  };
  const normalizedLanguage = normalizeLanguage(language);

  return normalizedLanguage;
};

/**
 * Maps language codes to supported TTS languages
 */
export const mapToSupportedTtsLanguage = (language: string): string => {
  console.log(`🗣️  Mapping "${language}" to supported TTS language...`);

  const supportedLanguages = ["en", "es", "fr", "de", "pt", "it"];
  const normalizedLang = language.toLowerCase().substring(0, 2);

  const result = supportedLanguages.includes(normalizedLang)
    ? normalizedLang
    : DEFAULT_TTS_LANGUAGE;

  return result;
};
